// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__9BlzK","actions":"PageTitle_actions__KsXVn","container":"PageTitle_container__Q3ERa","left":"PageTitle_left__54OUh","center":"PageTitle_center__5uRZW"};